export const removePdfExtension = (filename: string) => {
  return filename?.replace(/\.pdf$/i, "") ?? "";
};
